<div class="upload-table">
  <p-table
    [value]="files"
    [scrollable]="true"
    [autoLayout]="true"
  >
    <ng-template pTemplate="header">
      <tr pFrozenColumn alignFrozen="top">
        <th pSortableColumn="team" alignFrozen="left" pFrozenColumn>
          Teams
          <p-sortIcon field="team"/>
        </th>
        <th >
          Upload members
        </th>
        <th pSortableColumn="date">
          Matrix date
          <p-sortIcon field="date"/>
        </th>
        <th >
          Actions
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-columns="columns" let-rowData>

        <tr>
          <td  alignFrozen="left" pFrozenColumn>
            {{ rowData["team"] }}
          </td>
          <td>
            <!-- Display team members invoking getTeamMembers method from team.service.ts  -->
             {{rowData["members"]}}
            
          </td>
          <td><!-- display date of the Skill Matrix -->
            {{ rowData["date"] | date: 'dd/MM/yyyy' }}  
          </td>
          <td>
            <button
              pButton
              type="button"
              class="p-button-danger p-button-rounded p-button-outlined"
              (click)="confirmAndDelete(rowData['team'], rowData['date'])"
            >
              <i class="pi pi-trash"></i>
              <span class="p-ml-2">Delete from DB</span>
            </button>
          </td>
        </tr>


    </ng-template>
  </p-table>
</div>
